import React from "react";
import { Modal, Flex, Text, Link } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { modal, header } from "./styles_vanilla.css";

type Props = {
  show: boolean;
  onHide: () => void;
};

const ContactSupportModal: React.FunctionComponent<Props> = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} className={modal}>
      <Modal.Header closeButton className={header}>
        <Modal.Title>
          <Text variant="h3">Contact Support</Text>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex flexDirection="column" gap={Sizes.MD}>
          <Flex justifyContent="center" flexGrow={1}>
            <Text variant="regular-md">
              Please send us an email and we&apos;ll get back to you within 24 hours, although
              usually much faster. If your issue is urgent, we are available by phone Monday to
              Friday between 9:00 am and 5:00 pm PT.
            </Text>
          </Flex>
          <Flex>
            <Link href="mailto:support@junipersquare.com" icon="envelope">
              support@junipersquare.com
            </Link>
          </Flex>
          <Flex>
            <Link href="tel:+14158412722" icon="phone">
              +1 (415) 841-2722
            </Link>
          </Flex>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default ContactSupportModal;
